import { ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SupplierOrders } from 'src/app/models/supplier-portal/supplier/supplierOrders.models';
import { OrderSupplierService } from 'src/app/services/portal-supplier/order-supplier.service';
import { ManufacturerPopoversService } from 'src/app/services/shared/manufacturer-popovers.service';

@Component({
  selector: 'app-history',
  standalone: false,
  templateUrl: './history.component.html',
  styleUrl: './history.component.scss',
})


export class HistoryComponent {
  @Input() accountId: number = null;
  loading: boolean = false;
  public readonly pageSize = 20;
  public readonly rowHeight = 44;

  public Order: SupplierOrders.IOrder[] = [];
  private readonly orderSupplierService = inject(OrderSupplierService);

  private readonly router = inject(Router);
  public mServ = inject(ManufacturerPopoversService);
  private cdr = inject(ChangeDetectorRef);

  ngOnInit() {
    this.getList();
  }

  public getList() {
    if (!this.accountId) {
      return;
    }
    this.orderSupplierService.getSupplier(this.accountId).subscribe((result) => {
      const supplierId = result?.supplier?.supplier_id;

      console.log('Supplier found', result);
      if (!supplierId) {
        return;
      }

      this.orderSupplierService.getClosedCertifications(supplierId)
        .subscribe((ordersResult) => {
          console.log('OrderResult in history', ordersResult);
          this.Order = ordersResult?.data?.supplier_certificates ?? [];
          this.loading = false;
          this.cdr.detectChanges();
          this.orderSupplierService.orderNumberCounter.next(this.Order.length);
        });
    });
  }


  public getRowClass = (context: { dataItem: SupplierOrders.IOrder }): string =>
    context.dataItem.is_partial ? 'partial-row' : '';

  public formatArticleCount(articles: number): string {
    return new Intl.NumberFormat('it-IT').format(articles).replace(/,/g, "'");
  }

  private getManufacturerBaseRoute(): string {
    if (this.router.url.startsWith('/active-orders')) {
      return 'active-orders';
    }

    if (this.router.url.startsWith('/manufacturer-list')) {
      return 'manufacturer-list';
    }

    return 'dashboard';
  }


  public openOrder(order: SupplierOrders.IOrder): void {
    void this.router.navigate(
      [`/${this.getManufacturerBaseRoute()}/order-history-manufacturer/${order.supplier_certificate_id}`],
      { state: { returnTab: 'history' } },
    );
  }

  /*public getDdtDate(orderId: number): string | null {
    const map = JSON.parse(localStorage.getItem('ddtDates') || '{}');
    return map[orderId] ?? null;s
  }*/

  public get gridHeight(): number {
    const minimumHeight = 164;
    const maximumHeight = 368;
    const headerHeight = 44;
    const gridChrome = 8;
    const visibleRows = Math.max(this.Order.length, 1);

    return Math.min(
      maximumHeight,
      Math.max(
        minimumHeight,
        headerHeight + visibleRows * this.rowHeight + gridChrome,
      ),
    );
  }
}
